import Pagination from './pagination';
import UrlUpdater from './url-updater';

//=============================================================================
// Handles filtering and pagination for PLP, search page, and blog list page.
//=============================================================================

export default class Collection {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {

      // Page state

      this.state = {
        urlUpdater: new UrlUpdater()
      };

      this.reset();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets/Resets the page
  //===========================================================================

  reset() {
    this.state.$collection = $('.js-collection');
    this.state.$items = null;
    this.state.$grid = null;
    this.state.$cache = null;
    this.state.sortOption = '';
    this.state.inStockOnly = false;
    this.state.filterCategories = {};

    // Set up the page if this is the PLP

    if (this.state.$collection.length) {
      this.state.$items = $('.js-collection-grid-item');
      this.state.$grid = $('.js-collection-grid');
      this.state.$cache = $('.js-collection-grid-cache');

      this.resetPagination();
      this.checkForParamsOnLoad();
      this.setupCollectionGrid();
    }
  }

  //===========================================================================
  // Resets the collection settings after a new collection loads via ajax
  //===========================================================================

  resetCollection() {
    if (this.state.$collection.length) {
      this.state.$items = $('.js-collection-grid-item');
      this.state.$grid = $('.js-collection-grid');
      this.state.$cache = $('.js-collection-grid-cache');
      this.state.pagination.set('currentPage', 1);
      this.checkForParamsOnLoad();
      this.setupCollectionGrid(true);
    }
  }

  //===========================================================================
  // Resets the pagination
  //===========================================================================

  resetPagination() {
    if (this.state.$pagination) {
      this.state.$pagination.remove();
      this.state.$pagination = null;
    }

    this.state.pagination = new Pagination(this.setupCollectionGrid.bind(this));
  }

  //===========================================================================
  // Runs all filters and populates collection grid with items
  //===========================================================================

  setupCollectionGrid(scrollToSectionTop) {
    this.sortItems();
    this.filterItems();
    this.state.pagination.updatePagination();

    $(document).trigger('resetGrids');
    $(document).trigger('revealImages');
    $(document).trigger('reloadReviewsWidget');

    const currentPage = this.state.pagination.get('currentPage');
    const paginationType = this.state.pagination.get('paginationType');

    if (scrollToSectionTop && !(currentPage > 1 && (paginationType === 'infinite' || paginationType === 'show_more'))) {
      $(document).trigger('scrollToPageTop');
    }
  }

  //===========================================================================
  // Sets up sort & filters based on URL params on page load
  //===========================================================================

  checkForParamsOnLoad() {
    const search = window.location.search.split('&');

    search.forEach((param) => {
      if (param && param.includes('order_by=')) {   // Sorting param
        const sort = param.split('order_by=')[1];
        $(`.js-collection-sort[value="${ sort }"]`).prop('checked', true);
        this.updateSortLabel();
        this.setSelectedSort(sort);
      } else if (param && param.includes('in_stock=')) {   // In-stock param
        const inStock = param.split('in_stock=')[1] === 'true';
        $('.js-collection-instock').prop('checked', inStock);
        this.setInStockOnly(inStock);
      } else if (param && param.includes('filter=')) {    // Filters param
        const filters = param.split('filter=')[1].replace(/,/g, '+').replace(/%20/g, ' ').split('+');
        filters.forEach((filter) => {
          $(`.js-collection-filter[value="${ filter }"]`).prop('checked', true);
        });
        this.setSelectedFilters();
      }
    });
  }

  //===========================================================================
  // Sorts the $items array based on the selected sort option
  //===========================================================================

  sortItems() {
    this.state.$items.sort((a, b) => {
      const $a = $(a);
      const $b = $(b);
      let val1;
      let val2;

      switch(this.state.sortOption) {
        case 'title-ascending':
          val1 = $a.data('title');
          val2 = $b.data('title');
          break;
        case 'title-descending':
          val1 = $b.data('title');
          val2 = $a.data('title');
          break;
        case 'price-ascending':
          val1 = $a.data('price');
          val2 = $b.data('price');
          break;
        case 'price-descending':
          val1 = $b.data('price');
          val2 = $a.data('price');
          break;
        case 'created-ascending':
          val1 = $b.data('published');
          val2 = $a.data('published');
          break;
        case 'created-descending':
          val1 = $b.data('published');
          val2 = $a.data('published');
          break;
        default:
          val1 = $a.data('index');
          val2 = $b.data('index');
      }

      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  //===========================================================================
  // Filters items in the grid
  //===========================================================================

  filterItems() {
    let matchingItemsCount = 0;

    this.state.$items.each((i, item) => {
      const $item = $(item);
      const isMatchingItem = this.validateItemForFilters($item);
      const paginationSize = this.state.pagination.get('paginationSize');
      let canShowItem = false;
      let pageNumber = 1;

      if (isMatchingItem) {
        matchingItemsCount += 1;
        pageNumber = Math.ceil(matchingItemsCount / paginationSize);
        $item.attr('data-page', pageNumber);
        canShowItem = this.state.pagination.validateItemForPagination(pageNumber);
      }

      if (canShowItem) {
        this.state.$grid.append($item);
        $item.find('[data-lazy-load-lock]').removeAttr('data-lazy-load-lock');
        $item.removeClass('hidden');
      } else {
        this.state.$cache.append($item);
        $item.addClass('hidden');
      }
    });

    this.state.pagination.set('totalCount', matchingItemsCount);
  }

  //===========================================================================
  // Checks if an item is valid based on selected filters
  //===========================================================================

  validateItemForFilters($item) {
    const tags = ($item.data('tags') || '').split(',');
    let matchingItem = true;

    // Invalidates items that don't match filters
    Object.values(this.state.filterCategories).forEach((category) => {
      let validCategory = false;

      category.forEach((option) => {
        if (tags.includes(option)) {
          validCategory = true;
        }
      });

      if (!validCategory) { matchingItem = false; }
    });

    // Invalidates sold-out items when the in-stock filter is selected
    if (this.state.inStockOnly && !$item.data('available')) {
      matchingItem = false;
    }

    return matchingItem;
  }

  //===========================================================================
  // Caches the in-stock option in the state
  //===========================================================================

  setInStockOnly(selected) {
    const option = selected ? selected : $('.js-collection-instock:checked').val();
    this.state.inStockOnly = option;
  }

  //===========================================================================
  // Caches the selected sort option in the state
  //===========================================================================

  setSelectedSort(selected) {
    const option = selected ? selected : $('.js-collection-sort:checked').val();
    this.state.sortOption = option || '';
  }

  //===========================================================================
  // Caches the selected filters in the state
  //===========================================================================

  setSelectedFilters() {
    const $checkboxes = $('.js-collection-filter:checked');
    const categories = {};

    $checkboxes.each((i, el) => {
      const $el = $(el);
      const value = $el.val();
      const category = $el.data('category') || 'default';

      if (value) {
        categories[category] = categories[category] || [];

        if (!categories[category].includes(value)) {
          categories[category].push(value);
        }
      }
    });

    this.state.filterCategories = categories;
  }

  //===========================================================================
  // Makes URL search param for selected filters
  //===========================================================================

  getUrlFilters() {
    this.setSelectedFilters();

    const filters = Object.values(this.state.filterCategories).map((arr) => {
      return arr.join(',');
    }).join('+');

    return !!filters ? 'filter=' + filters : '';
  }

  //===========================================================================
  // Makes URL search param for the sort option
  //===========================================================================

  getUrlSort() {
    this.setSelectedSort();

    const sort = this.state.sortOption;
    return sort ? 'order_by=' + sort : '';
  }

  //===========================================================================
  // Makes URL search param for in-stock filter
  //===========================================================================

  getUrlInStock() {
    this.setInStockOnly();

    const inStock = this.state.inStockOnly;
    return inStock ? 'in_stock=true' : '';
  }

  //===========================================================================
  // Updates filter inputs from user clicks
  //===========================================================================

  updateFilterInputs(e) {
    const $target = $(e.currentTarget);

    // Disables multi-select for checkboxes with "radio-checkbox" class.
    // This is only for categories that do not have the "OR" option enabled.

    if ($target.data('radio-checkbox')) {
      const $parent = $target.closest('.js-collection-filter-list');
      const $checkboxes = $parent.find('.js-collection-checkbox');

      $checkboxes.each((i, checkbox) => {
        const $checkbox = $(checkbox);
        const id = $checkbox.data('id');

        if ($checkbox[0] && $checkbox.is(':checked') && id != $target.data('id')) {
          $(`.js-collection-checkbox[data-id="${ id }"]`).prop('checked', false);
        }
      });
    }

    // Syncs checkbox selection between desktop and mobile versions

    if ($target.hasClass('js-collection-checkbox')) {
      const id = $target.data('id');
      const checked = $target.is(':checked');

      $(`.js-collection-checkbox[data-id="${ id }"]`).prop('checked', checked);
    }

    // Auto applies filters for checkbox with data-apply="true"
    // For checkboxes that don't require users to click the "Apply" button

    if ($target.data('apply')) {
      this.updateFilters();
    }
  }

  //===========================================================================
  // Re-renders the collection items based on the filters
  //===========================================================================

  updateFilters() {
    const splitUrl    = window.location.pathname.split('/collections/')[1] || '';
    const search      = window.location.search ? window.location.search.replace('?', '').split('&').filter(function(s) { return !s.match('page=') && !s.match('filter=') && !s.match('sort_by=') && !s.match('order_by=') && !s.match('in_stock='); }).join('&') : '';
    const sort        = this.getUrlSort();
    const filters     = this.getUrlFilters();
    const inStock     = this.getUrlInStock();
    const collectionName = splitUrl.split('/')[0];
    const params = [search, filters, sort, inStock].filter((param) => { return !!param }).join('&');
    const url = `/collections/${ collectionName }${ params ? '?' + params : '' }`;

    this.state.pagination.set('currentPage', 1);
    this.updateSortLabel();
    this.state.urlUpdater.updateUrl(url);
    this.setupCollectionGrid(true);
  }

  //===========================================================================
  // Clears all filters
  //===========================================================================

  clearFilters(e) {
    const $target = $(e.currentTarget);

    e.preventDefault();

    // This will clear all filters and sort options
    $('.js-collection-checkbox').prop('checked', false);

    // If you don't want to clear the sort option, use this line instead:
    // $('.js-collection-checkbox').not('.js-collection-sort').prop('checked', false);

    if ($target.data('apply')) {
      this.updateFilters();
    }
  }

  //===========================================================================
  // Updates the label for the currently selected sort option
  //===========================================================================

  updateSortLabel() {
    const $sort = $('.js-collection-sort:checked');
    const $labels = $('.js-collection-sort-label');
    const name = $sort.data('name');

    $labels.each((i, label) => {
      const $label = $(label);
      let content = '';

      if (name && $label.hasClass('desktop-hidden')) {
        content = `${ name }`;
      } else if ($label.hasClass('desktop-hidden')) {
        content = 'Select';
      } else if (name) {
        content = `<b>Sort:</b> ${ name }`;
      } else {
        content = 'Sort';
      }

      $label.html(content);
    });
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('change', '.js-collection-checkbox', this.updateFilterInputs.bind(this));
    $(document).on('click', '.js-collection-filter-clear', this.clearFilters.bind(this));
    $(document).on('click', '.js-collection-apply', this.updateFilters.bind(this));
    $(document).on('resetCollection', this.resetCollection.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
  }
}
